import { env } from "@/env";
import { createBrowserClient } from "@supabase/ssr";
import { Database } from "./schema";

// Online ordering only uses Supabase for realtime broadcasts and never signs a
// guest in. Without a persisted session auth-js skips its cross-tab navigator
// lock, which otherwise gets stolen between tabs and rejects with an unhandled
// "Lock was stolen by another request" AbortError.
export function createClient() {
  return createBrowserClient<Database>(
    env.VITE_SUPABASE_URL,
    env.VITE_SUPABASE_PUBLISHABLE_KEY,
    {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    },
  );
}

export const sendBroadcast = async ({
  userId,
  event,
  payload,
}: {
  userId: string;
  event: string;
  payload: unknown;
}) => {
  const supabaseClient = createClient();
  const broadcastChannel = supabaseClient.channel(
    `broadcast-channel-${userId}`,
  );

  console.log(
    `Sending broadcast event ${event} to ${userId}: ${JSON.stringify(payload)}`,
  );

  const result = await broadcastChannel.httpSend(event, payload);

  console.log(result);

  return result;
};
